// @flow

import * as React from 'react';

import { useLocation } from 'react-router-dom';

import { DiscountInput } from './DiscountInput';

type RefType = HTMLInputElement;

export function AddDiscount({
  ref,
}: {
  ref: React.RefSetter<RefType | null>,
}): React.MixedElement | null {
  const location = useLocation();

  const overviewPage = location.pathname.includes('overview');

  if (!overviewPage) return null;

  // $FlowFixMe[incompatible-type-arg]
  return <DiscountInput ref={ref} />;
}
